import React from 'react';
import Layout from '../../components/Layout';
import ProductsGrid from '../store/ProductsGrid';

const Health = () => {
    return (
        <Layout
            title="Health Datebooks"
            description="2027 Caregiver and Health Companion Datebooks for organizing health, wellness, appointments, medications, and medical information."
        >
            <div className="text-center mt-5">
                <h1>Health Datebooks</h1>
                <p>
                    Practical planners designed to help you organize health,
                    wellness, appointments, medications, and important medical information.
                </p>
            </div>

            <ProductsGrid datebookType="HEALTH" />
        </Layout>
    );
};

export default Health;